<template>
<div class="strike">
	<span>OK</span>
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.strike {
	display: block;
	text-align: center;
	overflow: hidden;
	white-space: nowrap;
	margin: 10px 0px;
	font-size: 13px;
}

.strike > span {
	position: relative;
	display: inline-block;
	color: #fff;
}

.strike > span:before,
.strike > span:after {
	content: "";
	position: absolute;
	top: 50%;
	width: 9999px;
	height: 1px;
	background: #fff;
}

.strike > span:before {
	right: 100%;
	margin-right: 15px;
}

.strike > span:after {
	left: 100%;
	margin-left: 15px;
}
</style>
